import styled from 'styled-components';

export const SHeading2 = styled.h2`
  padding: ${props => (props.padding ? props.padding : 'unset')};
  color: ${props =>
    props.colour
      ? (props.colour === 'pastel_blue' && props.theme.colors.pastel_blue) ||
        (props.colour === 'white' && '#ffffff') ||
        (props.colour === 'primary' && props.theme.colors.primary)
      : props.theme.colors.main};

  display: ${props => props.display || 'block'};
  text-decoration: ${props => props.isUnderlined && 'underline'};
  ${props => props.$extraStyle && props.$extraStyle};
`;
